module.exports = __webpack_public_path__ + "static/scale-model-of-denton-convention-&-visitors-bureau-in-denton-texas-e92660ed757560cfe31dfb78933cf6e2.png";